import CommonHeader from './CommonHeader';

const NormalHeader = (props) => (
  <div style={{ padding: '8px 16px' }}>
    <CommonHeader {...props} />
  </div>
); //NormalHeader

export default NormalHeader;
